import { Card, CardContent } from "@/components/ui/card";
import { MetricCard } from "@/components/dashboard/MetricCard";
import { useTestAnalytics } from "@/hooks/useTestAnalytics";
import { Users, Target, Clock, UserCheck, Briefcase } from "lucide-react";

interface TestAnalyticsSummaryProps {
  testId: string;
}

export function TestAnalyticsSummary({ testId }: TestAnalyticsSummaryProps) {
  const { data: analytics, isLoading } = useTestAnalytics(testId);

  if (isLoading) {
    return (
      <div className="mb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-24 bg-muted animate-pulse rounded-lg" />
          ))}
        </div>
      </div>
    );
  }

  if (!analytics) return null;

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        <MetricCard
          title="Total Responses"
          value={analytics.totalResponses}
          icon={Users}
          description={`${analytics.completedResponses} completed`}
          iconColor="text-blue-500"
        />
        
        <MetricCard
          title="Mean Score"
          value={analytics.averageAIScore !== null ? `${analytics.averageAIScore}%` : "N/A"}
          icon={Target}
          iconColor="text-green-500"
        />
        
        <MetricCard
          title="Mean Time"
          value={analytics.averageTimeToComplete !== null ? `${analytics.averageTimeToComplete}m` : "N/A"}
          icon={Clock}
          iconColor="text-orange-500"
        />
        
        <MetricCard
          title="Shortlisted"
          value={analytics.shortlistedCount}
          icon={UserCheck}
          iconColor="text-purple-500"
        />
        
        <MetricCard
          title="Hired"
          value={analytics.hiredCount}
          icon={Briefcase}
          iconColor="text-emerald-500"
        />
      </div>
    </div>
  );
}